import { render, staticRenderFns } from "./Validacion.vue?vue&type=template&id=5bce52b2"
import script from "./Validacion.vue?vue&type=script&lang=js"
export * from "./Validacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports